import { createIndicator } from "@nexus/widget-kit";

/**
 * OTT piracy indicator: the shared metric indicator on the `ott-piracy-metrics` source only, so an
 * author picks a metric of this domain and never a source.
 */
const indicator = createIndicator({
  id: "ott-piracy-indicator",
  name: "OTT piracy indicator",
  description: "One or two figures of the OTT piracy report, with their trend.",
  source: "ott-piracy-metrics",
  sources: ["ott-piracy-metrics"],
});

export const { manifest, Component, defaultConfig, settings } = indicator;
export default indicator;
